import React from 'react';

import { Box, CircularProgress } from '@mui/material';

const PageLoader = () => {
  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress />
    </Box>
  );
};

export default PageLoader;
